<template>
  <div data-component-group="threads-panel" data-component="latest-deals">
    <slot name="beforeForm" />

    <v-list lines="two" class="merchant-deals-list">
      <template v-for="deal in deals" :key="deal.id">
        <v-list-item class="merchant-deal-item">
          <v-list-item-title>
            {{ deal.title }}
          </v-list-item-title>
          <v-list-item-subtitle>
            <span class="deal-price">
              {{ `${deal.price}${deal.currency.symbol}` }}
            </span>
            <div class="deal-meta">
              <span class="deal-time">
                {{ getDealTime(deal) }}
              </span>
              <span class="separator">
                {{ '|' }}
              </span>
              <span class="deal-poster">
                {{ `@${deal.poster}` }}
              </span>
            </div>
          </v-list-item-subtitle>

          <template #append>
            <v-btn
              icon
              ripple
              :title="`View deal '${deal.title}'`"
              @click="viewDeal(deal)"
            >
              <v-icon color="grey-lighten-1"> info </v-icon>
            </v-btn>
          </template>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
  import { openUrlInNewWindow } from '../../../utils';

  export default {
    props: {
      deals: {
        type: Array,
        required: true,
      },
    },
    computed: {
      today() {
        return this.$dayjs();
      },
    },
    methods: {
      getDealTime(deal) {
        return this.getDate(deal.date);
      },
      viewDeal(deal) {
        openUrlInNewWindow(window.open(), deal.url);
      },
      isToday(date) {
        return this.today.diff(this.$dayjs(date), 'days') === 0;
      },
      isSameHour(date) {
        return this.today.diff(this.$dayjs(date), 'hours') === 0;
      },
      getDate(date) {
        return this.isToday(date) && this.isSameHour(date)
          ? `${this.$dayjs(date).format('mm')} minutes ago`
          : this.isToday(date)
            ? `${this.today.diff(date, 'hours')} hours ago`
            : this.$dayjs(date).format('YYYY-MM-DD');
      },
    },
  };
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='threads-panel'] {
  &[data-component='latest-deals'] {
    background-color: map.get($colors, shades, 'white');

    .v-list {
      background: transparent;
    }

    .merchant-deal-item {
      .v-btn {
        min-width: 30px;
      }
    }

    .deal-price {
      color: map.get($colors, shades, 'black');
      font-weight: bold;
      margin: 0 6px 0 0;
    }

    .deal-meta {
      display: inline-block;

      .separator {
        margin: 0 4px;
      }
    }
  }
}
</style>
